//commit里的第一个参数对应mutations.js里的对应方法名

// /**
//  * 设置pdf方向
//  * @param commit
//  * @param payload
//  */
// export const siderCollapsed = ({commit}, payload) => {
//   commit("siderCollapsed", payload);
// };
/**
 * 设置 当前正在加载 个数
 * @param commit
 * @param payload
 */
export const loading = ({commit}) => {
  commit("loadingCounter", 1);
}
export const loaded = ({commit}) => {
  commit("loadingCounter", -1);
}
/**
 * 保存登录信息
 * @param commit
 * @param payload
 */
export const setUserInfo=({commit}, payload)=>{
  commit("setUserInfo", payload);
}

export const setRouters=({commit}, payload)=>{
  commit("setRouters", payload);
}

export const setAreaOrgs=({commit}, payload)=>{
  commit("setAreaOrgs", payload);
}

export const setLoginBy = ({commit}, payload)=>{
  commit("setLoginBy", payload);
}
export const setUserSetting = ({commit}, payload) =>{
  commit("setUserSetting", payload);
}



// WEBPACK FOOTER //
// ./src/store/actions.js